<section class="report-section">
    <div *ngIf="sectionTitle" class="section-title">{{sectionTitle}}</div>

    <div *ngIf="sectionDescription" class="section-desc">{{sectionDescription}}</div>

    <main class="content">
        <section class="chart" appEcharts [initialOption]="initialOption" [optionToBeUpdate]="optionToBeUpdate"></section>
    </main>
</section>
